import React from 'react';
import {
  Box,
  Flex,
  Text,
  ListIcon,
  List,
  ListItem,
  Container,
  ListProps,
  ListItemProps,
  TextProps,
  IconProps,
  AspectRatio,
} from '@chakra-ui/react';
import { FiCheck } from 'react-icons/fi';
import ReactPlayer from 'react-player';

const DisplayData: React.FC<{
  data: string | string[];
  listProps?: ListProps;
  listItemProps?: ListItemProps;
  listIconProps?: IconProps;
  textProps?: TextProps;
}> = ({ data, listItemProps, listProps, listIconProps, textProps }) => {
  if (Array.isArray(data)) {
    return (
      <List spacing={3} {...listProps}>
        {data?.map((item, index) => (
          <ListItem
            {...listItemProps}
            key={`${item?.substring(0, 10)}_${index}`}
            display="flex"
            {...listItemProps}
          >
            <ListIcon
              mt="5px"
              as={FiCheck}
              color="primary.500"
              {...listIconProps}
            />
            {item}
          </ListItem>
        ))}
      </List>
    );
  }

  return (
    <Text
      fontSize={{ xs: '14px', md: '16px' }}
      marginBottom="40px"
      {...textProps}
    >
      {data}
    </Text>
  );
};

const DetailsAndOverview: React.FC<{
  highlights?: string | string[];
  overviewTitle?: string;
  highlightsTitle?: string;
  overview?: string | string[];
  keyTopicsTitle?: string;
  keyTopicsTitleHighlights?: string | string[];
  YTLink?: string;
}> = ({
  highlights,
  overview,
  overviewTitle = 'Event Overview',
  highlightsTitle = 'Program Details',
  keyTopicsTitle,
  keyTopicsTitleHighlights,
  YTLink,
}) => (
  <Container maxW="1199px">
    <Flex
      justify="center"
      w="100%"
      flexDirection={{
        xs: 'column',
        md: 'row',
      }}
      id="program-details"
      px={{ xs: '20px', lg: '50px' }}
      pt={{ xs: '50px', lg: '50px' }}
      position="relative"
    >
      {/* <Img
        src="/svg/lhs-design-vc101.svg"
        alt="lhs-design-vc101.svg"
        position="absolute"
        left="0px"
        top="159px"
        display={{ xs: 'none', md: 'block' }}
      /> */}
      {/* <Img
        objectFit="contain"
        src="/webp/handshaking.webp"
        alt="side picture"
        w={{ md: '45%' }}
        h="auto"
      /> */}
      <Box mt={{ xs: '1.5rem', md: '0' }} w={{ md: '50%' }}>
        {overview && (
          <>
            <Flex
              alignItems="center"
              fontWeight="700"
              fontSize={{ xs: '24px', md: '34px' }}
              lineHeight="130%"
              color="text.darkHead"
              marginBottom="15px"
              minHeight="44px"
              gap="2"
              flexWrap="wrap"
              mt="24px"
            >
              {overviewTitle}
            </Flex>

            <DisplayData data={overview} />
          </>
        )}

        {highlights && (
          <>
            <Text
              fontWeight="700"
              fontSize={{ xs: '24px', md: '34px' }}
              lineHeight="130%"
              color="text.darkHead"
              marginBottom="15px"
              mt="24px"
            >
              {highlightsTitle}
            </Text>
            <DisplayData data={highlights} />
          </>
        )}

        {keyTopicsTitleHighlights && (
          <>
            <Text
              fontWeight="700"
              fontSize={{ xs: '24px', md: '34px' }}
              lineHeight="130%"
              color="text.darkHead"
              marginBottom="15px"
              mt="24px"
            >
              {keyTopicsTitle}
            </Text>
            <DisplayData data={keyTopicsTitleHighlights} />
          </>
        )}
      </Box>
    </Flex>
    {YTLink && (
      <AspectRatio
        mx="auto"
        ratio={16 / 9}
        maxWidth="100%"
        width="1176px"
        mb="30px"
        mt="30px"
        overflow="hidden"
      >
        <ReactPlayer
          url={YTLink}
          controls
          playing={false}
          width="100%"
          height="100%"
        />
      </AspectRatio>
    )}
  </Container>
);

export default DetailsAndOverview;
